import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Divider, Checkbox, CircularProgress, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import endpoints from '../constants/endpoints';
import useFetch from '../hooks/useFetch';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import SearchInput from './SearchInput';
import SearchFacetInput from './SearchFacetInput';
import { on } from 'events';
import Close from '@mui/icons-material/Close';
import navbar_background from '../assets/navbar_background.svg';
import useApiRequest from '../services/apiRequest';



type Props = {
    open: boolean,
    onClose: (() => void)
    facet: string
    facetName: string
}




function FacetsDialog({ open, onClose, facet, facetName }: Props) {
    const { queryStringConverter} = useApiRequest();
    const { description, filters, searchType: search_type, setFilters, cleanFilters } = useContext(GlobalStateContext);
    const { selectedFacets, setSelectedFacets } = useContext(GlobalStateContext);


    const [pageSizeFacet, setPageSizeFacet] = useState<number>(10);
    const [currentPageFacet, setCurrentPageFacet] = useState<number>(0);

    const { selectedRowsFacet, setSelectedRowsFacet } = useContext(GlobalStateContext);
    const { data, error, loading } = useFetch(`${endpoints.ALL_FACETS}${queryStringConverter({ target_facet: facet, page: currentPageFacet, size: pageSizeFacet, search_type: search_type })}`, JSON.stringify({ description, ...filters }), "POST")

    const removerSelectedRowsFacet = (row: any) => {
        let linhas = selectedRowsFacet.filter((linha) => linha.id !== row.id);
        setSelectedRowsFacet(linhas);
    }

    const renderCellInfo = (params: GridRenderCellParams) => {
        return (
            <IconButton color="primary" aria-label="add to shopping cart" onClick={() => {
                removerSelectedRowsFacet(params);
            }}>
                <IndeterminateCheckBoxIcon color='error' />
            </IconButton>
        )
    }

    const handleClose = () => {
        setCurrentPageFacet(0);
        onClose();
    }

    const renderCellCheck = (params: GridRenderCellParams) => {
        return (
            <Checkbox
                checked={selectedRowsFacet.some((row) => row.id === params.id)}
                onChange={() => {
                    let updatedRows = [...selectedRowsFacet];
                    const rowIndex = selectedRowsFacet.findIndex((row) => row.id === params.id);
                    if (rowIndex !== -1) {
                        updatedRows.splice(rowIndex, 1);
                    } else {
                        updatedRows.push(params.row);
                    }
                    setSelectedRowsFacet(updatedRows);
                }}
            />
        )
    }

    const columns: GridColDef<any>[] = [
        {
            field: 'selecionar',
            headerName: '',
            width: 20,
            editable: true,
            renderCell: renderCellCheck,
            sortable: false
            
        },
        {
            field: 'label',
            headerName: 'Nome',
            width: 400,
            editable: true,
            sortable: false
        },
        {
            field: 'qtd',
            headerName: 'Qtd',
            width: 70,
            editable: true,
            sortable: false
        },

    ];

    const handleSave = () => {
        setSelectedFacets(selectedRowsFacet);
        setFilters({ ...filters, [facet]: selectedRowsFacet.filter((row) => row.facet == data?.facets[0].filter).map((row) => row.id) });
        setCurrentPageFacet(0);
        onClose();
    }

    useEffect(() => {
        if (open) {
            setSelectedRowsFacet(selectedFacets);
        }
    }, [open])




    return (<Dialog
        open={open}
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth='md' 
    >
        <DialogTitle color='white'  sx={{bgcolor: '#00617b' , backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }}>
            <Typography variant='h4'>{facetName}</Typography>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 15,
                    top: 15,
                }}
            >
                <Close sx={{color:"white"}}/>
            </IconButton>
        </DialogTitle>
        <DialogContent sx={{ textAlign: 'center' }}>
            <Box sx={{ m: 1 }}>
                <SearchFacetInput facet={facet} />
            </Box>

            <Box sx={{ height: 420, width: '100%', display: 'flex' }}>
                <TableContainer component={Paper} sx={{ width: '30%', }}>
                    <Typography variant='h6' sx={{ textAlign: 'center', m: 1 }}>Opções selecionadas</Typography>
                    <Table aria-label="simple table">

                        <TableBody>
                            {selectedRowsFacet.map((row) => (
                                row.facet == data?.facets[0].filter ?
                                    <TableRow key={row.id}>
                                        <TableCell sx={{ width: '5%' }}>
                                            <IconButton color="primary" aria-label="add to shopping cart" sx={{ m: -2 }} onClick={() => {
                                                removerSelectedRowsFacet(row);
                                            }}>
                                                <IndeterminateCheckBoxIcon color='error' />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell>
                                            {row.label}
                                        </TableCell>
                                    </TableRow> : <></>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Divider orientation="vertical" flexItem sx={{ mr: 3, ml: 3 }} />

                <DataGrid
                    hideFooterSelectedRowCount
                    paginationMode='server'
                    pageSize={pageSizeFacet}
                    rows={data?.facets[0].facets.map((facet: any) => { return { id: facet.label, label: facet.label, qtd: facet.count, facet: data?.facets[0].filter } }) || []}
                    rowCount={data?.facets[0].facets_total}
                    page={currentPageFacet}
                    onPageSizeChange={(newPageSize) => setPageSizeFacet(newPageSize)}
                    onPageChange={(newPage) => setCurrentPageFacet(newPage)}
                    columns={columns}
                    sx={{ fontSize: 13 }}
                    loading={loading}
                    rowsPerPageOptions={[10, 25, 50]}
                />

            </Box>

        </DialogContent>
        <DialogActions >
            <Button onClick={handleSave} variant='contained'>Aplicar</Button>
        </DialogActions>
    </Dialog>);
}

export default FacetsDialog;
